module.exports = __webpack_public_path__ + "img/1724829294453-lemper.jpg.ffdaae4c.webp";